/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box, BoxProps } from "@mui/material";
import getRandomId from "../../Utils/getRandomId";
import CommandBarMenu from "../CommandBarMenu";
import variablesScss from "../../Themes/variables.module.scss";

export interface CommandBarProps {
    children?: React.ReactNode;
    className?: string;
    sx?: BoxProps["sx"];
    items?: React.ReactNode;
    search?: React.ReactNode;
}

export default function CommandBar(props: CommandBarProps) {
    return (
        <Box
            sx={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                height: "3rem",
                lineHeight: "3rem",
                minHeight: "3rem",
                backgroundColor: "white",
                flexWrap: "wrap",
                overflowY: "hidden",
                borderBottom: `1px solid ${variablesScss.colorsDefaultBorder}`,
                ...props.sx,
            }}
            className={props.className}
        >
            {!!props.items && <CommandBarMenu items={props.items} />}
            {props.search}
            {React.Children.map(props.items, item => {
                if (React.isValidElement(item) && item.key === undefined) {
                    return React.cloneElement(item, { key: getRandomId() })
                }

                return item;
            })}
            {props.children}
        </Box>
    );
}
